import React from "react";
import Card from "./Card";
import chooseOne from '../../../assets/images/top-dest-fight-9.png'
import chooseTwo from '../../../assets/images/top-dest-fight-10.png'
import chooseThree from '../../../assets/images/top-dest-fight-9.png'
const chooseUsDetails = [
    {
        image: `${chooseOne}`,
        title: "Exclusive Deals",
        superOffer:"Enjoy exciting deals on flights,hotels, buses,car rentals and tour packages.",
        
    },
    {
        image: `${chooseTwo}`,
        title: "Trust And Safety",
        superOffer:"Keeps our users Reputation safe and secured.",
       

    },
    {
        image: `${chooseThree}`,
        title: "Exclusive Deals",
        superOffer:"Enjoy exciting deals on flights,hotels, buses,car rentals and tour packages.",
        
    },
    
];

const WhyChooseUsDetails = () => {
    
    return (
        <>
            {chooseUsDetails.length > 0 && chooseUsDetails.map((card, index) => (
                <Card
                    key={index}
                    image={card.image}
                    title={card.title}
                    superOffer={card.superOffer}
                    customClass="col-12 col-lg-4 mb-3 mb-lg-0"
                    parentClass="choose-section"
                    card="card"
                    cardBody="card-body"
                    
                />
            ))}
        </>
    );
};

export default WhyChooseUsDetails;
